"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var Box_1 = require("../Box");
var Spinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? "secondary" : _c, rest = __rest(_a, ["size", "color"]);
    var colors = (0, styled_components_1.useTheme)().colors;
    return (react_1.default.createElement(Box_1.Box, __assign({}, rest),
        react_1.default.createElement("svg", { "aria-label": "loading", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2400 2400", width: size, height: size, style: { display: "block" } },
            react_1.default.createElement("g", { strokeWidth: "200", strokeLinecap: "round", stroke: colors[color], fill: "none" },
                react_1.default.createElement("path", { d: "M1200 600V100" }),
                react_1.default.createElement("path", { opacity: ".5", d: "M1200 2300v-500" }),
                react_1.default.createElement("path", { opacity: ".917", d: "M900 680.4l-250-433" }),
                react_1.default.createElement("path", { opacity: ".417", d: "M1750 2152.6l-250-433" }),
                react_1.default.createElement("path", { opacity: ".833", d: "M680.4 900l-433-250" }),
                react_1.default.createElement("path", { opacity: ".333", d: "M2152.6 1750l-433-250" }),
                react_1.default.createElement("path", { opacity: ".75", d: "M600 1200H100" }),
                react_1.default.createElement("path", { opacity: ".25", d: "M2300 1200h-500" }),
                react_1.default.createElement("path", { opacity: ".667", d: "M680.4 1500l-433 250" }),
                react_1.default.createElement("path", { opacity: ".167", d: "M2152.6 650l-433 250" }),
                react_1.default.createElement("path", { opacity: ".583", d: "M900 1719.6l-250 433" }),
                react_1.default.createElement("path", { opacity: ".083", d: "M1750 247.4l-250 433" }),
                react_1.default.createElement("animateTransform", { attributeName: "transform", attributeType: "XML", type: "rotate", keyTimes: "0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667", values: "0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199", dur: "0.83333s", begin: "0s", repeatCount: "indefinite", calcMode: "discrete" })))));
};
exports.Spinner = Spinner;
exports.Spinner.displayName = "Spinner";
//# sourceMappingURL=Spinner.js.map